import type { ReactNode } from 'react';
import { clsx } from 'clsx';

type Props = {
  children: ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
};

export function SectionLabel({ children, tone = 'light', className }: Props) {
  return (
    <div
      className={clsx(
        'flex items-center gap-3 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.12em]',
        tone === 'dark' ? 'text-lime-400' : 'text-charcoal-600',
        className,
      )}
    >
      <span className="h-px w-9 bg-lime-500" />
      <span>{children}</span>
    </div>
  );
}
